import {useEffect, useState} from "react";
import {findItemsWithPagination} from "../api/itemApiClient";

// There is no dedicated "list all property values" endpoint, so this derives the
// filter options by scanning a broad, unfiltered page of items for distinct
// {itemPropertyValueId, name, value} entries across all of their variants.
export const useItemPropertyValueOptions = (reloadTrigger) => {
    const [propertyValueOptions, setPropertyValueOptions] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();

        findItemsWithPagination(1, 200, null, null, abortController.signal)
            .then(
                (data) => {
                    const seen = new Map();

                    (data.items || []).forEach((item) => {
                        (item.variants || []).forEach((variant) => {
                            (variant.properties || []).forEach((property) => {
                                seen.set(property.itemPropertyValueId, property);
                            });
                        });
                    });

                    setPropertyValueOptions(Array.from(seen.values()));
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [reloadTrigger]);

    return {propertyValueOptions : propertyValueOptions};
};
